export function validateEmail(email: string, appAccess = false) {
  var regexp = /\S+@\S+\.\S+/;
  if (appAccess) {
    return regexp.test(email);
  }
  return regexp.test(email) || email.length === 0;
}

export function validatePhone(phoneNum: string, appAccess = false) {
  let length = phoneNum.length;
  if (appAccess) {
    return length === 11;
  }
  return length === 11 || length === 1 || phoneNum === "";
}

export function validateUserFields(
  first: string,
  last: string,
  emailVal: any,
  phoneVal: any,
  level: any,
  levelRequired: boolean,
  appAccess: boolean,
) {
  const errors: string[] = [];
  //check name
  if (!first || !last) {
    errors.push("First and Last Name are Required");
  }
  //check email
  if (emailVal && !validateEmail(emailVal)) {
    errors.push("Email is in Invalid Format");
  }
  //check phone
  if (phoneVal && !validatePhone(phoneVal?.toString() || "")) {
    errors.push("Phone is in Invalid Format");
  }
  if (appAccess) {
    //check email or phone
    if (validateEmail(emailVal, true) === false && validatePhone(phoneVal?.toString() || "", true) === false) {
      errors.push("Valid Email or Phone is Required for Mobile App Access");
    }
  }
  //check program and level
  if (levelRequired && !level) {
    errors.push("Program Level is Required when Program is Selected");
  }
  return errors;
}
